import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Box, Typography, Button } from "@mui/material";

import { MerchantTrack } from "components/MerchantTrack";
import { Link } from "components/html/Link";

import { i18n } from "services/i18nService";
import { getListHeaderText } from "services/utility/list";
import { formatListPageFilterList } from "services/utility/subheaders";

import { usePrivileges } from "hooks/usePrivileges";

import { USER_PRIVILEGE, OBJECT_TYPES } from "appConstants";

export function Header(props) {
  const { objectType, retrievalParams, totalRecords, statusQueryParam } = props;

  const { hasPrivilegesOrIsAdmin } = usePrivileges();

  const dateFormat = useSelector(
    (state) => state.userCompanySettings.localization.dateFormat
  );
  const showUpsShipments = useSelector(
    (state) => state.userCompanySettings.settings.showUpsShipments
  );
  const allowProcessPayment = hasPrivilegesOrIsAdmin([
    USER_PRIVILEGE.processPayment,
  ]);

  const allowProcessTemplates = hasPrivilegesOrIsAdmin([
    USER_PRIVILEGE.buildAssemblies,
  ]);

  const paymentsBoarded = useSelector(
    (state) => state.userCompanySettings.settings.paymentsBoarded
  );

  const [subheaderText, setSubheaderText] = useState("");

  useEffect(() => {
    async function getSubheader() {
      if (retrievalParams && retrievalParams.filterSettings) {
        const formattedFilters = await formatListPageFilterList(
          objectType,
          retrievalParams.filterSettings,
          statusQueryParam
        );
        setSubheaderText(formattedFilters);
      }
    }
    getSubheader();
  }, [objectType, retrievalParams, dateFormat, statusQueryParam]);

  function getObjectHeaderButton() {
    switch (objectType) {
      case OBJECT_TYPES.FORM_TEMPLATE.fullString:
        return (
          <Button>
            <Link to="/configuration/list/templatelibrary">
              {i18n("objectType.templatelibrary.SentencePlural")}
            </Link>
          </Button>
        );
      case OBJECT_TYPES.PAYMENT.fullString:
        return allowProcessPayment ? (
          <Button>
            <Link to={paymentsBoarded ? "/fspayment" : "/sospayments"}>
              {i18n("objectType.fspayment.SentencePlural")}
            </Link>
          </Button>
        ) : null;
      case OBJECT_TYPES.SHIPMENT.fullString:
        return showUpsShipments ? (
          <Button>
            <Link to="/upsshipment">
              {i18n("objectType.upsshipment.SentencePlural")}
            </Link>
          </Button>
        ) : null;
      case OBJECT_TYPES.FS_PAYMENT.fullString:
        return <MerchantTrack />;

      case OBJECT_TYPES.PROCESS.fullString:
        return allowProcessTemplates ? (
          <Button>
            <Link to="/configuration/list/processtemplate">
              {i18n("objectType.processtemplate.SentencePlural")}
            </Link>
          </Button>
        ) : null;

      default:
        return null;
    }
  }

  return (
    <div data-testing="listPageHeader">
      <Box
        mb={1}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "end",
        }}
      >
        <Box>
          <Typography variant="h2">
            {i18n(`objectType.${objectType}.SentencePlural`)}
          </Typography>
          <Typography>{subheaderText}</Typography>
        </Box>
        <Box>
          {getObjectHeaderButton()}
          <div>
            <Typography sx={{ float: "right", pr: "8px" }}>
              {getListHeaderText(objectType, totalRecords, retrievalParams)}
            </Typography>
          </div>
        </Box>
      </Box>
    </div>
  );
}
